/**
 * Standardized action icons for dropdown menus
 *
 * Uses Lucide React for consistency across the platform.
 * All action-related dropdowns should use these icons.
 *
 * @module components/actions/constants
 */

import {
  AlertTriangle,
  CheckCircle,
  Compass,
  Download,
  Globe,
  Layers,
  MessageSquare,
  MoreHorizontal,
  Network,
  Power,
  RefreshCw,
  Server,
  Settings,
  Share,
  Snowflake,
  Tag,
  Trash2,
  X,
  XCircle,
} from 'lucide-react';

/**
 * Action icons used across all sections
 *
 * Standardized on Lucide React for:
 * - Better tree-shaking
 * - Consistent visual style
 * - Modern icon library
 */
export const ACTION_ICONS = {
  // Annotate actions
  COMMENT: MessageSquare,
  ADD_TAG: Tag,
  REMOVE_TAG: X,

  // Distribute actions
  EXPORT: Download,
  SHARE: Share,

  // Managed actions
  FREEZE: Snowflake,
  ACTIVATE: Power,
  DELETE: Trash2,
  APPROVE: CheckCircle,
  REJECT: XCircle,

  // Scan actions
  RESCAN: RefreshCw,
  AFFILIATION: CheckCircle,
  COMPREHENSIVE_SCAN: Layers,
  NETWORK_SCAN: Network,
  PORT_SCAN: Server,
  WEB_CRAWL: Compass,
  WEB_SCAN: Globe,

  // Vulnerability actions
  STATUS_CHANGE: Settings,
  SEVERITY_CHANGE: AlertTriangle,

  // Dropdown triggers
  MORE_ACTIONS: MoreHorizontal,
} as const;

/**
 * Icon size for all action icons
 */
export const ICON_SIZE = 'size-4';

/**
 * Helper to render action icon with consistent size
 */
export const renderActionIcon = (
  Icon: (typeof ACTION_ICONS)[keyof typeof ACTION_ICONS]
) => {
  return <Icon className={ICON_SIZE} />;
};
